export default () => ({
  expiry: null,
  remaining: null,

  init () {
    this.expiry = new Date()
    this.expiry.setMinutes(this.expiry.getMinutes() + 2)
    this.setRemaining()
    setInterval(() => {
      this.setRemaining()
    }, 1000)
  },

  setRemaining () {
    const diff = this.expiry - new Date().getTime()
    this.remaining = parseInt(diff / 1000) >= 0 ? parseInt(diff / 1000) : 0
  },

  days () {
    return {
      value: this.remaining / 86400,
      remaining: this.remaining % 86400
    }
  },

  hours () {
    return {
      value: this.days().remaining / 3600,
      remaining: this.days().remaining % 3600
    }
  },

  minutes () {
    return {
      value: this.hours().remaining / 60,
      remaining: this.hours().remaining % 60
    }
  },

  seconds () {
    return {
      value: this.minutes().remaining
    }
  },

  format (value) {
    return (`0${parseInt(value)}`).slice(-2)
  },

  time () {
    const minutes = this.format(this.minutes().value)
    const seconds = this.format(this.seconds().value)

    return {
      minutes,
      seconds
    }
  }
})
